import React from 'react'
import PropTypes from 'prop-types'

function AddToCartButton({ offerId, itemId, price }) {
  const addToCart = (e) => {
    e.preventDefault()

    axios.post(`/api/internal/cg/items/${itemId}/cart_items`, { offer_id: offerId })
      .then(onAddToCartSuccess)
      .catch(onAddToCartFailure)
  }

  function prepareTrackViewItemList(attributes) {
    let trackableAttributes = {}
    const {
      id,
      title,
      affiliation,
      index,
      authorUsername,
      category,
      subcategory,
      itemCategory3,
      itemCategory4,
      itemCategory5,
      productType,
      locationId,
      discount,
      searchQuery,
    } = attributes
    const currentPrice = parseFloat(attributes.price)
    // take list index data from local storage
    const savedListIndex = localStorage.getItem(`indexClickPriceOffer${id}`)

    trackableAttributes = {
      item_id: String(id),
      item_name: title,
      affiliation,
      currency: 'USD',
      index: savedListIndex || index || null,
      item_brand: authorUsername,
      item_category: category,
      item_category2: subcategory,
      item_category3: itemCategory3,
      item_category4: itemCategory4,
      item_category5: itemCategory5,
      item_list_id: searchQuery,
      item_list_name: searchQuery,
      item_variant: productType,
      location_id: locationId && locationId.join('_'),
      price: currentPrice,
      quantity: 1,
    }

    if (discount > 0) {
      const currentDiscount = parseFloat(discount)

      trackableAttributes.price = currentPrice - currentDiscount
      trackableAttributes.discount = currentDiscount
    }

    // remove list index data from local storage if it exists
    if (savedListIndex) {
      localStorage.removeItem(`indexClickPriceOffer${id}`)
    }

    return trackableAttributes
  }

  const onAddToCartSuccess = (response) => {
    const { meta } = response.data
    const { trackingCartItems } = meta

    dataLayer.push({
      event: 'add_to_cart',
      user_id: App.config.userId || '',
      event_source: 'price offer',
      ecommerce: {
        currency: 'USD',
        value: price,
        items: [prepareTrackViewItemList(trackingCartItems[0])]
      },
      _clear: true,
    })

    const message = `${response.data.included[0].attributes.title} has successfully been added to the cart`
    App.events.publish('app:cart:added', response.data)
    App.events.publish('app:cart:add', response.data.data.attributes.kind)
    App.events.publish('app:notification:flash:success', message)
  }

  const onAddToCartFailure = (xhr) => {
    App.events.publish('app:notification:flash:error', xhr.response.data.errors.detail)
  }

  return (
    <button
      className="button u-ml10"
      onClick={addToCart}
    >{`Add to cart for ${numeral(price).format('$0.00')}`}
    </button>
  )
}

AddToCartButton.propTypes = {
  offerId: PropTypes.number.isRequired,
  itemId: PropTypes.number.isRequired,
  price: PropTypes.number.isRequired,
}

export default AddToCartButton
